<template>
  <!-- Шапка с параметрами в зависимости от страницы
  Передается: currentRoute = роут для отображения заголовка
  filter = true/false для отображения кнопки фильтра + @openModalFilter
  createBtn = true/false для отображения кнопки создания + @createElement -->
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="true" :createBtn="true" @openModalFilter="openModalFilter" @createElement="createElement"></top-navbar>
  </keep-alive>

  <section class="container-content orders-container-content">
    <div class="container-tablist">
      <!-- Табы для переключения между активными заказами и историей заказов. -->
      <div class="tablist">

        <div :class="[activeTab === 'orders' ? 'active tab' : 'tab']" @click="isReady && changeTab('orders')">
          <span>Заказы</span>
          <div class="tab-border-bottom"></div>
        </div>
        
        <!-- Отменен и Отгружен -->
        <div :class="[activeTab === 'history' ? 'active tab' : 'tab']" @click="isReady && changeTab('history')">
          <span>История заказов</span>
          <div class="tab-border-bottom"></div>
        </div>

      </div>
    </div>

    <!-- Область для вывода списка названий полей, по которым настроена фильтрация. 
    Отмена фильтрации по полю должна быть доступна по клику на пиктограмму рядом 
    с названием поля в области В и в окне фильтра, открываемого по клику на кнопку Б. 
    Настройка должна быть индивидуальной для каждого пользователя.  -->
    <div class="container-filters">
      <!-- <span class="filter-span" v-for="(header, index) in headersFilterActive" :key="index" v-show="header.value != 0 && header.value != null && header.value != ''"> -->
      <span class="filter-span" v-for="(header, index) in headersFilterActive" :key="index">
        {{header.name}}
        <span class="container-icon" title="Отменить фильтр" @click="delFilter(index)">
          <mdicon name="close" width="10"/> 
        </span> 
      </span>
    </div>

    <transition name="fade">
      <section v-if="!isReady" class="absolute-center-block">
        <div class="container-loading">
          <span class="loader loader-default loader-dark"></span>
        </div>
      </section>
    </transition>

    <transition name="fade">
      <section v-if="isReady" class="container-table">

        <table-component
          v-if="!isEmpty(data)"
          :currUserID="currUserID"
          :allHeaders="allHeaders"
          :headersDefault="headersDefault"
          :dataObject="data"
          :defaultData="defaultData"
          :type="typePage"
          @sort-table="selectSortField"
          @open-page="openOrder"
          @copy-page="copyOrder"
          @edit-page="editOrder"
        ></table-component>

        <div v-else class="empty-orders-notification">
          Список заказов пуст.
        </div>

      </section>
    </transition>

  </section>

  
  <div v-if="showModalFilter" class="modal-vue modal-filter" ref="modal">
    <div class="scroll-container">
      <div 
        class="block-cb"
        v-for="(header, index) in headersFilter" 
        :key="index"
      >
        <div class="filter-block">
          <div class="container-filter-field">
            <label>{{ header.name }}</label>
            <!-- <select v-model="fieldType"> -->
            
            <div id="container-field-icon" class="container-field-icon">

              <select class="select-type-field" v-model="header.selectedType" @change="handleTypeChange(header)">
                <option v-for="(label, value) in header.types" :key="value" :value="value">
                  {{ label }}
                </option>
              </select>

              <!-- точно -->
              <section v-if="header.selectedType == 'exactly'"> 
                <span v-if="header.type == 'INT' || header.type == 'DECIMAL'">
                  <input v-model="header.value" type="number">
                </span>
                <span v-else-if="header.type == 'VARCHAR' && index != 'status' && index != 'region' && index != 'shipmentMethod' && index != 'division'">
                  <input v-model="header.value" type="text">
                </span>
                <span v-else-if="header.type == 'DATETIME'">
                  <input v-model="header.value" type="date">
                </span>

                <!-- Блок для выборки со статусами -->
                <select-component 
                  v-if = "index == 'status'"
                  :selected = "header.value"
                  :options = "statusOrders"
                  :selectedType = "header.selectedType"
                  :defaultFields = "defaultFields"
                  @selectedElements="selectedElements"
                ></select-component>

                <!-- Блок для выборки регионов -->
                <select-component 
                  v-if = "index == 'region'"
                  :selected = "header.value"
                  :options = "regionsOrders"
                  :selectedType = "header.selectedType"
                  :defaultFields = "defaultFields"
                  @selectedElements="selectedRegions"
                ></select-component>
                
                <select-component 
                  v-if = "index == 'shipmentMethod'"
                  :selected = "header.value"
                  :options = "shipmentOrders"
                  :selectedType = "header.selectedType"
                  :defaultFields = "defaultFields"
                  @selectedElements="selectedShipments"
                ></select-component>

                <select-component 
                  v-if = "index == 'division'"
                  :selected = "header.value"
                  :options = "typeProductionOrders"
                  :selectedType = "header.selectedType"
                  :defaultFields = "defaultFields"
                  @selectedElements="selectedDivision"
                ></select-component>

              </section>

              <!-- диапазон -->
              <section v-else-if="header.selectedType == 'period'">
                <div class="filter-two-block" v-if="header.type == 'INT' || header.type == 'DECIMAL'">
                  <input v-model="header.value[0]" type="number">
                  <span>—</span>
                  <input v-model="header.value[1]" type="number">
                </div>
                <div class="filter-two-block" v-else-if="header.type == 'VARCHAR'">
                  <input v-model="header.value[0]" type="text">
                  <span>—</span>
                  <input v-model="header.value[1]" type="text">
                </div>
                <div class="filter-two-block" v-else-if="header.type == 'DATETIME'">
                  <input v-model="header.value[0]" type="date">
                  <span>—</span>
                  <input v-model="header.value[1]" type="date">
                </div>
              </section>

              <!-- подстрока -->
              <section v-else-if="header.selectedType == 'substring'">
                <span v-if="header.type == 'INT' || header.type == 'DECIMAL'">
                  <input v-model="header.value" type="number">
                </span>
                <span v-else-if="header.type == 'VARCHAR'">
                  <input v-model="header.value" type="text">
                </span>
                <span v-else-if="header.type == 'DATETIME'">
                  <input v-model="header.value" type="date">
                </span>
              </section>

              <mdicon 
                v-show="header.value != null && header.value != '' && index != 'status' && index != 'region' && index != 'shipmentMethod' && index != 'division' && header.selectedType != 'period'"
                class="clear-field-icon" 
                :class="[header.type != 'VARCHAR' ? 'number-clear-icon' : '']"
                title="Очистить поле" 
                name="close" 
                width="11" 
                height="11" 
                @click="clearField(index)"
              /> 

              <mdicon class="del-field-icon" title="Скрыть поле" name="close" width="11" height="11" @click="hideField(index)"/> 

            </div>
          </div>
        </div>
        
      </div>
    </div>
    <!-- Блок для добавления полей фильтрации -->
    <div class="easyBtn flex-space-between mb-15 mt-15">
      <span id="addField" class="span-link add-field mr-4" @click="addFilterFields()">Добавить поле</span>
      <span class="span-link del-field" @click="getDefaultFilterFields()">Вернуть поля по умолчанию</span>
      
    </div>

    <div v-show="showFields" class="absolute-block">
      <span class="container-icon" title="Закрыть" @click="closeModalToFilter">
        <mdicon name="close" width="22" height="22"/> 
      </span> 
      <div 
        class="block-cb block-field-hover"
        v-for="(header, index) in allHeadersForCheck" 
        :key="index"
        @click="addFieldToFilter(index)"
      >
        <input 
          type="checkbox" 
          :value="index"
          v-model="selectedFieldsToFilter"
        >
        {{ header }}
      </div>
    </div>

    <div class="flex-center-block mt-6">
      <button 
        class="btn btn-default"
        type="submit"
        title="Поиск по заказам"
        @click="saveFilters()"
      >
        <mdicon name="magnify" width="21px"/> 
        <span>Найти</span>
      </button>
      <button 
        class="btn btn-cancel"
        type="submit"
        title="Очистить фильтр"
        @click="delAllFilters()"
      >
        Сбросить
      </button>
    </div>
  </div>

  <!-- Затемнение фона -->
  <!-- <div v-if="showModalFilter" class="overlay"></div> -->
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import SelectComponent from "../components/SelectComponent.vue";
import TableComponent from "../components/TableComponent.vue";
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: 'OrdersPage',
  components: {
    TopNavbar,
    SelectComponent,
    TableComponent
  },
  data() {
    return {
      typePage: 'order',
      isReady: false,
      selectedFieldsToFilter: [],
      activeTab: 'orders',
      startDate: '',
      endDate: '',
      startDateShip: '',
      endDateShip: '',
      headersFilter: {},
      headersFilterActive: {},
      headersDefaultFilter: {
        id: {
          name: "ID",
          value: "",
        }, 
        orderNumber: {
          name: "№ Заказа",
          value: ""
        }, 
        created: {
          name: "Дата создания", 
          value: ""
        },
        total: {
          name: "Сумма",
          value: ""
        }, 
        status: {
          name: "Статус",
          value: ""
        },
      },
      headersDefault: {   
        id: "ID", 
        orderNumber: "№ Заказа", 
        created: "Дата создания", 
        total: "Сумма", 
        status: "Статус", 
        shipmentDate: "Дата отгрузки", 
        region: "Регион",
        shipmentMethod: "Способ доставки",
        user: "Пользователь"
      },
      allHeaders: {
        id: "ID", 
        // order_1c_guid: "Guid заказа", 
        orderNumber: "№ заказа", 
        created: "Дата создания", 
        modified: "Дата изменения заказа", 
        total: "Сумма", 
        status: "Статус", 
        orderWeight: "Вес",
        shipmentDate: "Дата отгрузки", 
        shipmentMethod: "Способ доставки",
        region: "Регион",
        shipmentAddress: "Адрес доставки",
        company: "Контрагент",
        division: "Тип продукции",
        orderNumberClient: "№ заказа клиента",
        consignee: "Грузополучатель",
        occupancyRate: "Процент загрузки",
        addInformation: "Дополнительная информация",
        inn: "ИНН",
        user: "Пользователь",
      },
      allHeadersForCheck : {},
      data: [],
      defaultData: [],
      showModalFilter: false,
      showFields: false,
      // currUserID: 1,
      statusOrders: ['Черновик', 'На согласовании (Поставщик)', 'На согласовании (Клиент)', 'В работе', 'Отменен', 'Отгружен'],  
      shipmentOrders: ['Доставка', 'Самовывоз'],  
      typeProductionOrders: ['BI (строительная изоляция)', 'TI (техническая изоляция)'],  
      regions: [],
      regionsOrders: [],
      fieldFilterTypes: {
        exactly: "Точно",
        substring: "По подстроке",
        period: "Диапазон"
      },
      fieldTypes: {
        id: "INT",
        // order_1c_guid: "VARCHAR",
        orderNumber: "VARCHAR",
        created: "DATETIME",
        modified: "DATETIME",
        orderWeight: "DECIMAL",
        status: "VARCHAR",
        shipmentDate: "DATETIME",
        shipmentMethod: "VARCHAR",
        region: "VARCHAR",
        shipmentAddress: "VARCHAR",
        shipmentAddress2: "VARCHAR",
        company: "VARCHAR",
        orderNumberClient: "VARCHAR",
        division: "VARCHAR",
        consignee: "VARCHAR",
        occupancyRate: "DECIMAL",
        total: "DECIMAL",
        addInformation: "VARCHAR",
        inn: "VARCHAR",
      },
      defaultFields: false,
      objMessages: {},
      allMessagesCount: 0,
      currUserID: "",
    }
  },

  mounted() {

    if(localStorage.getItem('userID') != undefined && localStorage.getItem('userID') != '') {
      this.currUserID = localStorage.getItem('userID')
    }

    // console.log(this.$route)
    this.getHeaders(); // получить заголовки для инит таблицы
    this.init();

    this.allHeadersForCheck = JSON.parse(JSON.stringify(this.allHeaders))
    delete this.allHeadersForCheck.company; // убрать контрагента
    delete this.allHeadersForCheck.user; // убрать пользователя
  },

  watch: {
    activeTab() {
      this.init()
    },
    // headersFilterActive: {
    //   handler(val) { 
    //     console.log("headersFilterActive")
    //     console.log(val)
    //   },
    //   deep: true
    // },
  },

  created() {
    // скрыть/показать абсолютный блок с выбором полей при клике за его пределы
    window.addEventListener('click', (event) => {
      hideBlock(event, document.getElementsByClassName("absolute-block")[0], 'addField')
      hideBlock(event, document.getElementsByClassName("modal-filter")[0], 'filter-btn')
    })

    const hideBlock = (e, block, id) => {
      if (block) {
        let styles = window.getComputedStyle(block)
        let displayValue = styles.getPropertyValue('display')
        if(displayValue == 'block' && e.target.id != id && !block.contains(e.target) && !isClickOnFilterButton(e, id) && !e.target.closest('.container-field-icon')) {
          if(id == 'addField') {
            this.showFields  = false
          } else if(id == 'filter-btn') {
            this.showModalFilter  = false
          }
        }
      }
    }

    // Функция, чтобы проверить, был ли клик по кнопке или её дочерним элементам
    const isClickOnFilterButton = (event, buttonId) => {
        const button = document.getElementById(buttonId);
        return button && (button.contains(event.target) || event.target.id === buttonId);
    };
  },

  methods: {

    async getDataHistory() {
      // this.typePage = 'orderHistory'
      let res = await GlobalRequest.request("/order/history", "GET")
      // console.log(res)
      if(res.success)
        this.data = res.data
      else
        this.data = []
    },

    async getData() {
      // this.typePage = 'order'
      let res = await GlobalRequest.request("/order/list", "GET")
      // console.log(res)
      if(res.success)
        this.data = res.data
      else
        this.data = []
    },

    async getDataFilter(type) {
      this.isReady = false
      let cloneHeadersFilterActive = JSON.parse(JSON.stringify(this.headersFilterActive))
      let objForRequest = {
        filter: Object.fromEntries(
          Object.entries(cloneHeadersFilterActive).map(([key, value]) => [
            key,
            {
              match: value.selectedType,
              value: Array.isArray(value.value)
                ? value.value.map(item => value.type === "DATETIME" ? this.timezoneDate(item) : String(item)) // Преобразование массива с учетом "DATETIME"
                : value.type === "DATETIME" ? this.timezoneDate(value.value) : String(value.value) // Преобразование одиночного значения
            }
          ])
        )
      };
      // console.log(objForRequest)

      let res = await GlobalRequest.request("/order/list/filter", "POST", objForRequest)
      // console.log(res)
      if(res.success)
        this.data = res.data
      else
        this.data = []

      if(type == "history") {
        this.data = this.data.filter(order => order.status == 'Отменен' || order.status == 'Отгружен')
        // console.log(this.data)
      }

        this.isReady = true
    },

    timezoneDate(data) {
      let formattedDate
      if(data != null && data != undefined && data != "") {
        const date = new Date(data)
        // console.log(date)
        
        
        // Получаем смещение в минутах и конвертируем его в часы и минуты
        const timezoneOffset = date.getTimezoneOffset();
        const hoursOffset = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
        const minutesOffset = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
        const sign = timezoneOffset > 0 ? '-' : '+';
        
        // Форматируем дату в нужном формате
        const isoString = date.toISOString().slice(0, 19);
        formattedDate = `${isoString}${sign}${hoursOffset}:${minutesOffset}`;
      }
      // console.log(formattedDate)

      return formattedDate;
    },

    async getRegions() {
      // this.typePage = 'order'
      let res = await GlobalRequest.request("/region/list", "GET")
      // console.log(res)
      if(res.success) {
        this.regions = res.data
        this.regionsOrders = this.regions.map(region => region.name);
      }
      else {
        this.regions = []
        this.regionsOrders = []
      }
    },

    async getMessages() {
      let res = await GlobalRequest.request("/order/draft", "GET")
      if(res.success) {
        let companyID = ""
        
        const values = Object.values(res.data.contrAgent);
        companyID = values[0].id
        // console.log("companyID = " + companyID)

        // companyID = res.data.partner.id
        if(!this.isEmpty(companyID)) {
          let resMessages = await GlobalRequest.request("/order-message/new-message-count/" + companyID, "GET")
          // console.log(resMessages)
          if(resMessages.success) {
            this.objMessages = resMessages.data
          }
        }
      }
    },

    // Инициализация
    async init() {
      this.isReady = false

      // Получить список регионов
      await this.getRegions()
      // получить новые сообщения
      await this.getMessages()

      // Заполнить активные фильтры
      let localHeadersFilterActive = localStorage.getItem(this.typePage + 'FilterFieldsActive_' + this.currUserID);
      if (localHeadersFilterActive != undefined && 
        localHeadersFilterActive != "" && 
        localHeadersFilterActive != null && 
        Object.keys(JSON.parse(localHeadersFilterActive)).length
      ) {
        // console.log("Фильтрация")
        // console.log(JSON.parse(localHeadersFilterActive))
        if (this.activeTab == "orders") {
          await this.getDataFilter()
        } else {
          await this.getDataFilter("history")
        }

      } 
      else {
        //Заполнить массив в зависимости от выбранной вкладки
        if (this.activeTab == "orders") {
          await this.getData()
        } else {
          await this.getDataHistory()
        }
      }

      // сортирвка по умолчанию      
      this.data.sort((a, b) => {
        let fieldA = 0
        let fieldB = 0
        
        if(a["created"] != undefined && b["created"] != undefined) {
          fieldA = this.sortingCell(a, "created")
          fieldB = this.sortingCell(b, "created")
        }

        if (fieldA > fieldB)  return -1;
        if (fieldA < fieldB)  return 1;
        else  return 0;
      });

      if(Object.keys(this.objMessages).length > 0) {
        this.data.forEach(item => {
          let key = item.id
          // Если существует, берем значение, иначе 0
          item.countNewMessages = this.objMessages[key] || 0;
        });
      }

      // console.log(this.data);
      // клон
      this.defaultData = this.cloneElement(this.data)
      this.isReady = true
    },

    // Выбор активной табы
    changeTab(tabName) {
      this.activeTab = tabName;
    },

    // Удалить фильтр по полю
    async delFilter(index) {
      delete this.headersFilterActive[index];
      localStorage.setItem(this.typePage + 'FilterFieldsActive_' + this.currUserID, JSON.stringify(this.headersFilterActive))
      await this.init()
    },

    // Закрыть модалку
    closeModal() {
      this.showFields = false;
    },

    closeModalToFilter() {
      this.showFields = false;
    },

    // Заполнить типы полей
    addFieldsTypes(key) {
      // && index != 'status' && index != 'region' && index != 'shipmentMethod' && index != 'division'
      const fieldType = this.fieldTypes[key];
      
      if (fieldType === "DATETIME" || fieldType === "DECIMAL" || fieldType === "INT") {
        this.headersFilter[key].types = {
          exactly: this.fieldFilterTypes.exactly,
          period: this.fieldFilterTypes.period
        };
        this.headersFilter[key].selectedType = 'exactly';
      } else {
        if(key !== 'status' && key != 'region' && key != 'shipmentMethod' && key != 'division') {
          this.headersFilter[key].types = {
            exactly: this.fieldFilterTypes.exactly,
            substring: this.fieldFilterTypes.substring
          };
        } else {
          this.headersFilter[key].types = {
            exactly: this.fieldFilterTypes.exactly
          };
        }
        this.headersFilter[key].selectedType = 'exactly';
      }
      this.headersFilter[key].type = fieldType;
      this.handleTypeChange(this.headersFilter[key])
    },

    // Получить заголовки
    getHeaders() {
      // Заголовки для фильтров
      let localHeadersFilter = localStorage.getItem(this.typePage + 'FilterFields_' + this.currUserID);
      if (localHeadersFilter != undefined && localHeadersFilter != "" && localHeadersFilter != null) {
        this.headersFilter = JSON.parse(localHeadersFilter)
      }
      else {
        this.headersFilter = this.headersDefaultFilter
        delete this.headersFilter.company; // убрать контрагента

        for (const key in this.headersFilter) {
          this.addFieldsTypes(key)
        }
      }

      for (let field in this.headersFilter) {
        this.selectedFieldsToFilter.push(field)
      }
      // console.log(this.selectedFieldsToFilter)

      // Заполнить активные фильтры
      let localHeadersFilterActive = localStorage.getItem(this.typePage + 'FilterFieldsActive_' + this.currUserID);
      if (localHeadersFilterActive != undefined && localHeadersFilterActive != "" && localHeadersFilterActive != null) {
        this.headersFilterActive = JSON.parse(localHeadersFilterActive)
      }

      // Чтобы исключить несоответствие отображения примененных фильтров с фильтрами в списке
      this.mergeFilters()

      // console.log(this.headersFilter)
      // console.log(this.headersFilterActive)

    },

    mergeFilters() {
      this.headersFilter = {
        ...this.headersFilter,
        ...JSON.parse(JSON.stringify(this.headersFilterActive))
      };
    },

    async editSavedFilters() {
      const dubleHeadersFilter = JSON.parse(JSON.stringify(this.headersFilter))
      this.headersFilterActive = Object.keys(dubleHeadersFilter).reduce((acc, key) => {
        const field = this.headersFilter[key];
        
        if (Array.isArray(field.value)) {
          // Проверяем, содержит ли массив хотя бы одно непустое значение
          if (field.value.some(item => item !== "")) {
            acc[key] = field; // Добавляем поле в новый объект, если в массиве есть непустое значение
          }
        } else if (field.value) {
          acc[key] = field; // Добавляем поле в новый объект, если значение не пустое
        }
        
        return acc; // Возвращаем акк для следующей итерации
      }, {});

      localStorage.setItem(this.typePage + 'FilterFieldsActive_' + this.currUserID, JSON.stringify(this.headersFilterActive))
      console.log("EDITED ACTIVE")
    },

    // Сохранить фильтр
    async saveFilters() {
      await this.editSavedFilters()
      
      // console.log(this.headersFilterActive)
      // console.log(this.headersFilter)

      localStorage.setItem(this.typePage + 'FilterFields_' + this.currUserID, JSON.stringify(this.headersFilter))  
      this.showModalFilter = false;

      if (this.activeTab == "orders") {
        await this.getDataFilter()
      } else {
        await this.getDataFilter("history")
      }

    },

    // Очистить все фильтры
    async delAllFilters() { 
      for(let key in this.headersFilter) {
        if(this.headersFilter[key].selectedType == 'period')
          this.headersFilter[key].value = ["", ""]
        else
          this.headersFilter[key].value = ""
      }

      await this.editSavedFilters()

      localStorage.setItem(this.typePage + 'FilterFields_' + this.currUserID, JSON.stringify(this.headersFilter))
      this.showModalFilter = false;

      await this.init()
    },

    // Проверка на пустоту
    isEmpty(data) {
      if(data != "" && data != " " && data != 0 && data != null) {
        if(data.length > 0) return false
      }
      else {
        return true
      }
    },

    parseCustomDate(dateStr) {
      const parts = dateStr.split(".");
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    },

    sortingCell(obj, field) {
      let fieldObj = 0
      if(obj[field] != "" && obj[field] != " " && obj[field] != 0 && obj[field] != null) {
        if(field == "orderWeight" || field == "total") {
          fieldObj = parseFloat(obj[field])
        }
        else if(field == "created" || field == "shipmentDate") {
          fieldObj = this.parseCustomDate(obj[field])
        }
        else {
          if(typeof obj[field] == "number")
            fieldObj = obj[field]
          else
            fieldObj = obj[field].toString().toLowerCase();
        }
      }
      return fieldObj
    },

    // Выбор поля для сортировки
    selectSortField(newDataObj) {
      this.data = newDataObj
    },

    // Открыть модалку для фильтрации
    openModalFilter() {
      this.showModalFilter = !this.showModalFilter
    },

    // Открыть заказ по id
    editOrder(id) {
      this.$router.push({
          path: '/order/detail',
          query: { id: id, type: 'edit' },
      });
    },

    // Добавить/Удалить id заголовка для фильтра в массив 
    addFieldToFilter(index) {
      if(this.selectedFieldsToFilter.includes(index)) {
        // скрыть поле
        this.hideField(index)
      }
      else {
        this.selectedFieldsToFilter.push(index);
        // Добавить выбранное поле в headersFilter
        let obj = {}
        obj.name = this.allHeaders[index]
        obj.value = ""
        this.headersFilter[index] = obj

        this.addFieldsTypes(index)
        
        if(this.headersFilter[index].selectedType == 'period')
          this.headersFilter[index].value = ["", ""]
        else
          this.headersFilter[index].value = ""

        localStorage.setItem(this.typePage + 'FilterFields_' + this.currUserID, JSON.stringify(this.headersFilter))
      }
    },

    // Показать/скрыть блок для добавления полей для фильтра
    addFilterFields() {
      this.showFields = !this.showFields
    },

    // Вернуть поля по умолчанию
    getDefaultFilterFields() {
      this.defaultFields = !this.defaultFields
      let defaultFilterObj = JSON.stringify(this.headersDefaultFilter)
      this.headersFilter = JSON.parse(defaultFilterObj)

      this.selectedFieldsToFilter = []
      for (let field in this.headersFilter) {
        this.addFieldsTypes(field)
        this.selectedFieldsToFilter.push(field)
      }

      localStorage.setItem(this.typePage + 'FilterFields_' + this.currUserID, JSON.stringify(this.headersFilter))

      this.showFields = false
    },

    // Скрыть поле фильтрации
    hideField(index) {
      this.selectedFieldsToFilter = this.selectedFieldsToFilter.filter(function(element) {
          return element !== index;
      });
      delete this.headersFilter[index];
      localStorage.setItem(this.typePage + 'FilterFields_' + this.currUserID, JSON.stringify(this.headersFilter))
    },

    clearField(index) {
      // console.log(index)
      // console.log(this.headersFilter[index])
      // console.log(this.headersFilter[index].value)
      
      this.headersFilter[index].value = ""
    },

    selectedElements(statuses) {
      this.headersFilter.status.value = statuses
      // console.log(statuses)
    },

    selectedRegions(regions) {
      this.headersFilter.region.value = regions
      // console.log(regions)
    },

    selectedShipments(shipments) {
      this.headersFilter.shipmentMethod.value = shipments
      // console.log(shipments)
    },

    selectedDivision(division) {
      this.headersFilter.division.value = division
      // console.log(division)
    },

    // Создать заказ
    createElement() {
      this.$router.push('/order/create');
    },

    // Скопировать заказ
    copyOrder(id) {
      this.$router.push({
        path: '/order/create',
        query: { id: id},
      });
    },

    // Открыть заказ по id
    openOrder(id) {
      this.$router.push({
        path: '/order/detail',
        query: { id: id, type: 'view' },
      });
    },

    handleTypeChange(header) {
      if (header.selectedType === 'period') {
        header.value = ["", ""]; // сбрасываем значения для диапазона
      } else {
        header.value = ""; // сбрасываем на обычное значение
      }
    },

    cloneElement(elem) {
      return JSON.parse(JSON.stringify(elem))
    }

  }
}
</script>